import { overrideTypographyStyles } from '../utils.js';
import { opalBase } from './base.js';
// Cardo only has 400 & 700 (no 500). So for Opal, we want all the same settings as the base except weight 400
export const cardo = overrideTypographyStyles(opalBase, { weight: 400 });
//# sourceMappingURL=cardo.js.map